import { render, staticRenderFns } from "./PaymentsAndCurrenciesTokens.vue?vue&type=template&id=65695fda&scoped=true&"
import script from "./PaymentsAndCurrenciesTokens.vue?vue&type=script&lang=js&"
export * from "./PaymentsAndCurrenciesTokens.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsAndCurrenciesTokens.vue?vue&type=style&index=0&id=65695fda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65695fda",
  null
  
)

export default component.exports